import ChackInstrument from "../components/configuration/chack/ChackInstrument";

const ChackInstrumentPage = () => {
    return (
        <ChackInstrument />
    )
}

export default ChackInstrumentPage;
